import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { loginActions as actions } from '.';
import { LoginApi } from '../LoginApi';
import { LoginUserModel } from './types';

export const api = new LoginApi();
function* doLogin(action: PayloadAction<LoginUserModel>) {
  try {
    const data = yield call(api.LoginUser, action.payload);
    yield put(actions.login_Success(data));
  } catch (error) {
    console.error(error);
    yield put(actions.login_Error(error as string));
  }
}
export function* LoginSaga() {
  yield takeLatest(actions.login.type, doLogin);
}
